/* istanbul ignore file */
import React from 'react';
import { SecurityContextTemplate, useAuthorization } from 'framework/authorization';
import { useArtifactStorageId } from 'domain/documents/artifactStorage/shared/useArtifactStorageId';

const ARTIFACT_STORAGE_FILE_CONTEXT = 'ArtifactStorageFile';

const ArtifactStorageFileContext = ({
  permissionToCheck,
  children,
}: {
  permissionToCheck: string | string[];
  children: React.ReactNode;
}) => {
  const { getPermissions } = useAuthorization();
  const fileId = useArtifactStorageId();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getPermissions}
      permissionToCheck={permissionToCheck}
      contextName={ARTIFACT_STORAGE_FILE_CONTEXT}
      id={fileId}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default ArtifactStorageFileContext;
